window.GlobalState = {
	sideMenuOpen: false,
	networkListingOpen: false,
	headerSearchOpen: false,

	setSideMenuOpen(open) {
		this.sideMenuOpen = open;
	},
	setNetworkListingOpen(open) {
		this.networkListingOpen = open;
	},
	setHeaderSearchOpen(open) {
		this.headerSearchOpen = open;
	},

	closeAllExcept(except) {
		if (except !== 'sideMenu') {
			this.setSideMenuOpen(false);
		}
		if (except !== 'networkListing') {
			this.setNetworkListingOpen(false);
		}
		if (except !== 'headerSearch') {
			this.setHeaderSearchOpen(false);
		}
	}
};
